import React, { useEffect } from 'react';
import { Col, Row } from 'reactstrap';
import { connect } from 'react-redux'

// components
import NewItem from "../../../components/buttons/newItem";
import AybAttributeList from "./_list";
import AybAttributeForm from "./_form";
import { showLoader } from "../../../components/loader/loader";

// actions
import { setApp, clearState } from "../../../redux/actions/generalActions/mainActions";
import { clearState as clearListState } from "../../../redux/actions/generalActions/listActions";

const AybAttribute = props => {
    const { viewMode, loading } = props.mainProps

    useEffect(() => {
        return () => {
            props.clearState();
            props.clearListState();
        }
    }, []);

    useEffect(() => {
        if (props.app !== null)
            props.setApp(props.app);
    },[ ]);

    return (
        <>
            { loading ? showLoader() : null}
            <NewItem />
            <Row>
                <Col md="12">
                    {(
                        function() {
                            switch (viewMode) {
                                case "LIST" :
                                    return <AybAttributeList />
                                case "FORM" :
                                    return <AybAttributeForm />
                                default:
                                    return null;
                            }
                        })()}
                </Col>
            </Row>
        </>
    );
}

const mapStateToProps = state => ({
    mainProps : state.mainProps
});

const mapActionsToProps = ({
    clearState,
    setApp,
    clearListState
});

export default connect(mapStateToProps, mapActionsToProps)(AybAttribute)